import { FormResponseValue } from "@tellescope/types-models";
import { SupportedSession } from "@tellescope/tanstack-query";
import { TellescopeFormFieldBaseProps } from "../../types";
import { ChargebeeFieldContent } from "./ChargebeeFieldContent";
import { Label } from "@tellescope/ui";
import { FieldDescription } from "../../FieldDescription";

export interface ChargebeeFieldProps extends TellescopeFormFieldBaseProps<"Chargebee"> {
  enduserId: string;
  formResponses: FormResponseValue[];
  session: SupportedSession;
  isOptional?: boolean;
  setCustomerId?: (customerId: string) => void;
}

export const ChargebeeField = ({ title, description, htmlDescription, required, ...rest }: ChargebeeFieldProps) => {
  return (
    <div className="space-y-1">
      {!!title && <Label required={required}>{title}</Label>}
      <FieldDescription description={description} htmlDescription={htmlDescription} />
      <ChargebeeFieldContent {...rest} />
    </div>
  );
};
